<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div v-if="isAex" class="aex-auth">
    <div class="aex-auth-background" aria-hidden="true">
      <i class="b b1"></i><i class="b b2"></i><i class="b b3"></i
      ><i class="b b4"></i> <i class="rings"></i><i class="rings r2"></i
      ><i class="sheen"></i>
    </div>
    <div class="aex-auth__page">
      <router-link class="aex-auth__back" to="/landing"
        >← На главную</router-link
      >
      <AuthHeader class="aex-auth__header" />
      <div class="aex-auth__brand">
        <router-link class="aex-auth__logo" to="/landing" aria-label="AEX">
          <img src="/aex/logo.png" alt="" />
          <span><b>AEX</b><small>Asset eXchange</small></span>
        </router-link>
        <p class="aex-auth__tag">
          <span class="aex-auth__rail" aria-hidden="true"><i></i></span>
          <span>From <em>Coins</em></span
          ><span>to <em>Cash</em></span
          ><span>with <em>Asset eXchange</em></span>
        </p>
      </div>
      <div class="aex-auth__form"><router-view /></div>
    </div>
    <a
      class="aex-auth__support"
      href="mailto:info@aex.cx"
      aria-label="Написать в поддержку"
      >✉</a
    >
  </div>
  <div v-else :class="b()">
    <div :class="b('container')">
      <AuthHeader />

      <div :class="b('content')">
        <AuthIntroduction :class="b('introduction')" />

        <router-view />
      </div>
    </div>
  </div>
</template>
